<template>
  <div id="login">
    <div class="logo"></div>
    <svg height="100%" width="100%">
      <g v-for="triangle in triangles" :key="triangle.id">
        <polygon
          :points="`${triangle.x1 + (triangleRandom - triangleRandom / 2 - 10)},${
            triangle.y1 + (triangleRandom - triangleRandom / 2 + 10)
          } ${triangle.x2 + (triangleRandom - triangleRandom / 2 - 10)},${
            triangle.y2 + (triangleRandom - triangleRandom / 2 + 10)
          } ${triangle.x3 + (triangleRandom - triangleRandom / 2 - 10)},${
            triangle.y3 + (triangleRandom - triangleRandom / 2 + 10)
          }`"
          :style="{ fill: triangle.fill, opacity: '0.1' }"
          class="triangle"
        />
        <polygon
          :points="`${triangle.x1 + (triangleRandom - triangleRandom / 2)},${
            triangle.y1 + (triangleRandom - triangleRandom / 2)
          } ${triangle.x2 + (triangleRandom - triangleRandom / 2)},${
            triangle.y2 + (triangleRandom - triangleRandom / 2)
          } ${triangle.x3 + (triangleRandom - triangleRandom / 2)},${
            triangle.y3 + (triangleRandom - triangleRandom / 2)
          }`"
          :style="{ fill: triangle.fill }"
          class="triangle"
        />
      </g>
    </svg>

    <div class="container">
      <div class="card">
        <div class="text">{{ message }}</div>
        <div v-if="!loading" class="link" @click="$router.push({ name: 'home' })">Retour</div>
      </div>
    </div>

    <div class="footer">© 2019 Washi</div>
  </div>
</template>

<script>
export default {
  name: 'InfoView',
  data() {
    this.colors = ['#154759', '#A3C9C7', '#2D6470'];
    return {
      triangleRandom: 50,
      borderRandom: 10,
      triangles: [
        {
          id: 0,
          fill: '#2D6470',
          x1: window.innerWidth - 30,
          y1: 230,
          x2: window.innerWidth - 110,
          y2: 210,
          x3: window.innerWidth - 100,
          y3: 250,
        },
        {
          id: 1,
          fill: '#A3C9C7',
          x1: window.innerWidth - 280,
          y1: 240,
          x2: window.innerWidth - 350,
          y2: 200,
          x3: window.innerWidth - 420,
          y3: 300,
        },
        {
          id: 2,
          fill: '#154759',
          x1: window.innerWidth - 230,
          y1: 350,
          x2: window.innerWidth - 150,
          y2: 310,
          x3: window.innerWidth - 170,
          y3: 430,
        },
        {
          id: 3,
          fill: '#A3C9C7',
          x1: window.innerWidth - 0,
          y1: 430,
          x2: window.innerWidth - 100,
          y2: 400,
          x3: window.innerWidth - 10,
          y3: 500,
        },
        {
          id: 4,
          fill: '#A3C9C7',
          x1: window.innerWidth - 190,
          y1: 150,
          x2: window.innerWidth - 220,
          y2: 170,
          x3: window.innerWidth - 240,
          y3: 120,
        },
        {
          id: 5,
          fill: '#154759',
          x1: window.innerWidth - 100,
          y1: 70,
          x2: window.innerWidth - 130,
          y2: 90,
          x3: window.innerWidth - 150,
          y3: 40,
        },
        {
          id: 6,
          fill: '#154759',
          x1: window.innerWidth - 350,
          y1: 100,
          x2: window.innerWidth - 330,
          y2: 120,
          x3: window.innerWidth - 300,
          y3: 70,
        },
      ],
      message: '',
      loading: false,
    };
  },
  async created() {
    if (this.$route.name === 'validateEmail') {
      this.message = "Merci de valider votre email d'inscription";
    } else if (this.$route.name === 'askResetPassword') {
      if (!this.$route.query.email) {
        this.message = 'Erreur lors de la verification de votre email';
      } else {
        this.loading = true;
        this.message = 'Un message de changement vous a été envoyé à : ' + this.$route.query.email;
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/buttons.scss';

svg {
  z-index: 10;
  position: fixed;
}

.logo {
  position: absolute;
  z-index: 1000;
  top: 55%;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: url('../assets/Logo_Washi_Login.svg?file-css');
  background-size: contain;
  background-position: right bottom;
  background-repeat: no-repeat;
  opacity: 1;
  &::before {
    position: absolute;
    content: '';
    height: 100%;
    width: 100%;
    left: -20px;
    background-image: url('../assets/Logo_Washi_Login.svg?file-css');
    background-size: contain;
    background-position: right bottom;
    background-repeat: no-repeat;
    opacity: 0.1;
    z-index: 1;
  }
}

.container {
  position: absolute;
  z-index: 2000;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  .card {
    position: absolute;
    top: calc(50% - 200px);
    left: calc((100% - 585px) / 2);
    width: 585px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 1px 7px 0 #dddddd;
    box-sizing: border-box;
    padding: 80px 124px;
    .text {
      font-weight: 600;
      font-size: 14px;
    }

    .logo-washi {
      width: 256px;
      height: 64px;
      margin: 0 auto;

      font-weight: 900;
      color: colors.$main-color;
      font-size: 24px;
      background-image: url('../assets/Logo_Washi.svg?file-css');
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
    }
  }
}
.link {
  text-decoration: underline;
  color: colors.$light-blue-color;
  margin: 4px 0;
  font-size: 12px;
  cursor: pointer;
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  padding: 8px 16px;
  font-size: 14px;
  color: #787878;
}
</style>
